import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react';

import track from 'services/tracking';
import PeekStream from 'components/PeekStream/PeekStream';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';


const PeekEventStream = () => {
  const { user: { username } } = UserStore;
  const {
    mainEventSecondaryStream,
    profileInfo,
    realityShow,
    setMainEventStream,
  } = ProfileStore;

  const room = profileInfo.username;

  const location = useLocation();
  const history = useHistory();

  const onSelect = useCallback(() => {
    track({
      eventname: 'realityShowPIPFeedSwitch',
      details: { realityShow: realityShow || {} },
      room,
      username,
    });

    const queryParams = new URLSearchParams(location.search);
    const streamName = queryParams.get('cam') || 'naked';

    if (streamName === 'naked') {
      queryParams.set('cam', 'uncut');
      history.push({ search: queryParams.toString() });

      setMainEventStream(false);
    } else {
      queryParams.set('cam', 'naked');
      history.push({ search: queryParams.toString() });

      setMainEventStream(true);
    }
  }, [
    history,
    location,
    realityShow,
    room,
    setMainEventStream,
    username,
  ]);

  if (!mainEventSecondaryStream?.cdnURL) {
    return null;
  }

  return (
    <PeekStream
      key={mainEventSecondaryStream?.cdnURL}
      changeEventStream={onSelect}
      index={-1}
      info={mainEventSecondaryStream}
      isEventPeek={true}
    />
  );
};

export default observer(PeekEventStream);
